import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { epostaRedirectFailGuard } from '@core/guards/eposta-redirect-fail.guard';
import { epostaRedirectReturnGuard } from '@core/guards/eposta-redirect-return.guard';
import { permissionGuard } from './core/guards/permission.guard';

export const routes: Routes = [
  {
    path: 'change-password',
    loadComponent: async () =>
      (await import('@pages/change-password/modules/change-password.component'))
        .ChangePasswordComponent,
  },

  {
    path: 'access-denied',
    loadComponent: async () =>
      (await import('@pages/access-denied/modules/access-denied.component'))
        .AccessDeniedComponent,
  },
  {
    path: 'subscription-type-list',
    loadChildren: async () =>
      (await import('@pages/subscription-type/subscription-type.routes')).routes,
    canActivate: [authGuard, permissionGuard],
    data: { requiredPermissions: ['SubscriptionType.Access.CanGet'] },
  },
  {
    path: 'auth-clients',
    loadChildren: async () =>
      (await import('@pages/auth-client/auth-client.routes')).routes,
    canActivate: [authGuard, permissionGuard],
    data: { requiredPermissions: ['AuthClient.Access.CanGet'] },
  },
  {
    path: 'subscription-plans',
    loadChildren: async () =>
      (await import('@pages/subscription-plan/subscription-plan.routes')).routes,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPermissions: [
        'SubscriptionPlan.Access.CanGet',
        'SubscriptionPlan.Method.GetSystemAdmin',
        'SubscriptionPlan.Method.GetClientAdmin',
      ],
    },
  },
  {
    path: 'login',
    loadChildren: async () => (await import('@pages/auth/auth.routes')).routes,
    canActivate: [authGuard],
  },
  {
    path: 'auth',
    loadChildren: async () => (await import('@pages/entra-auth/entra-auth.routes')).routes,
  },

  {
    path: 'pricing/return-not-found',
    loadComponent: async () =>
      (await import('@pages/subscription/modules/pricing-return-not-found/pricing-return-not-found.component'))
        .PricingReturnNotFoundComponent,
  },
  {
    path: 'pricing/:SessionId/success/:SuccessCode',
    canActivate: [epostaRedirectReturnGuard],
    loadComponent: async () =>
      (await import('@pages/subscription/modules/subscription-plan-pricing/subscription-plan-pricing.component'))
        .SubscriptionPlanPricingComponent,
  },
  {
    path: 'pricing/:SessionId/fail/:SuccessCode',
    canActivate: [epostaRedirectFailGuard],
    loadComponent: async () =>
      (await import('@pages/subscription/modules/pricing-payment-failed/pricing-payment-failed.component'))
        .PricingPaymentFailedComponent,
  },
  {
    path: 'pricing/:SessionId',
    loadComponent: async () =>
      (await import('@pages/subscription/modules/subscription-plan-pricing/subscription-plan-pricing.component'))
        .SubscriptionPlanPricingComponent,
  },
  {
    path: 'payment/pending',
    title: 'Pagesa në përpunim',
    loadComponent: async () =>
      (await import('@pages/payment/modules/payment-pending/payment-pending.component')).PaymentPendingComponent,
  },
  {
    path: 'payment/pok/result',
    title: 'POK payment result',
    loadComponent: async () =>
      (await import('@pages/payment/modules/pok-payment-result/pok-payment-result.component'))
        .PokPaymentResultComponent,
  },
  {
    path: 'subscriptions',
    loadChildren: async () =>
      (await import('@pages/subscription/subscription.routes')).routes,
    canActivate: [authGuard, permissionGuard],
    data: { requiredPermissions: ['Subscription.Access.CanGet'] },
  },
  {
    path: 'payments',
    loadChildren: async () =>
      (await import('@pages/payment/payment.routes')).routes,
    canActivate: [authGuard]
  },
  {
    path: 'contracts',
    loadChildren: async () =>
      (await import('@pages/contracts/contracts.routes')).routes,
    canActivate: [authGuard],
  },
  {
    path: 'users',
    loadChildren: async () =>
      (await import('@pages/user/user.routes')).routes,
    canActivate: [authGuard],
  },
  {
    path: 'profiles',
    loadChildren: async () =>
      (await import('@pages/profile/profile.routes')).routes,
    canActivate: [authGuard],
  },
  {
    path: 'roles',
    loadChildren: async () =>
      (await import('@pages/role/role.routes')).routes,
    canActivate: [authGuard],
  },
  {
    path: 'business-clients',
    loadChildren: async () =>
      (await import('@pages/business-client/business-client.routes')).routes,
    canActivate: [authGuard],
  },
  {
    path: 'gen-objects',
    loadChildren: async () =>
      (await import('@pages/gen-object/gen-object.routes')).routes,
    canActivate: [authGuard, permissionGuard],
    data: { requiredPermissions: ['GenObject.Access.CanGet'] },
  },
  {
    path: 'wallet-history',
    loadChildren: async () =>
      (await import('@pages/wallet-history/wallet-history.routes')).routes,
    canActivate: [authGuard, permissionGuard],
    data: { requiredPermissions: ['Payment.Method.GetSystemAdmin'] },
  },
  {
    path: 'dashboard',
    loadComponent: async () =>
      (await import('@pages/dashboard/modules/dashboard.component'))
        .DashboardComponent,
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full' },
];

